import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { isEmpty, head } from 'lodash';

import { pageTypeUpdate } from '../../../product/list/slice';
import {
  PAGE_TYPE,
  LIST_PER_PAGES,
  LIST_PER_PAGES_M,
} from '../../../product/list/constants/index';

interface Props {
  device: string;
}

export default function useProductListPage({
  device,
}: Props) {
  const dispatch = useDispatch();

  const pageUpdate = useCallback(() => {
    const url = new URL(location.href);
    const urlParams = url.searchParams;
    const page = PAGE_TYPE.find((param) => !isEmpty(urlParams.get(param.code)));
    const perPageConstants = device === 'pc' ? LIST_PER_PAGES : LIST_PER_PAGES_M;

    if (!page) {
      return;
    }

    const pageParamCode = urlParams.get(page.code) || '';
    const perPage = perPageConstants.filter((it) => it.type === page.type);
    const headPerPage = head(perPage);

    if (!headPerPage) {
      return;
    }

    dispatch(pageTypeUpdate(page.type, pageParamCode, headPerPage.count));
  }, [device, dispatch]);

  return { pageUpdate };
}
